export default "assets/images/logo-6124433b.png";